<template>
  <div class="dialog-body">
    <el-dialog
      v-if="dialogVisible"
      title="仓单解押提示"
      align="center"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
      ref="dialogRef"
    >
      <div class="result">
        <el-form :model="form" ref="dischargeApplicationRef">
          <el-form>
            <el-form-item label="可用库存：" :label-width="formLabelWidth">
              <el-input v-model="form.canUseStockQuantity" disabled></el-input>
            </el-form-item>
            <el-form-item label="出库数量：" :label-width="formLabelWidth">
              <el-input v-model="form.outStockQuantity" disabled></el-input>
            </el-form-item>
            <el-row :gutter="24">
              <el-col :span="24" v-if="!isSatisfyNeeds">
                <span style="text-align: center; display: block"
                  >可用库存小于出库数量，请先添加库存或者修改出库数量</span
                >
              </el-col>
            </el-row>
          </el-form>
        </el-form>
      </div>
      <FileTable ref="fileTableRef" :isShowDownBtn="isShowDownBtn" :attachments="attachments" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure" v-if="isSatisfyNeeds">确认申请</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import FileTable from '@/components/business/FileTable/index.vue';
  import superviseBillApi from '@/api/park/superviseBill';
  export default {
    name: 'dischargeApplicationDialog',
    props: ['selectData'],
    data() {
      return {
        dialogVisible: false,
        form: {
          canUseStockQuantity: null,
          outStockQuantity: '',
          id: null,
        },
        formLabelWidth: '100px',
        tableData: [],
        attachments: [],
        billNo: '',
        isShowDownBtn: false,
        loading: false,
        isSatisfyNeeds: true,
      };
    },
    methods: {
      // 打开弹窗
      openDialog() {
        this.dialogVisible = true;
      },
      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false;
      },
      // 确认申请
      async handleSure() {
        // 1.表单数据
        const baseFormData = this.form;
        // 2.附件
        const attachments = this.attachments;
        const postData = {
          ...baseFormData,
          attachments,
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
        };
        console.log(postData, 'postData');
        const { data } = await this.$axios.post(superviseBillApi.BILL_RELEASE, postData);
        if (data.code == 0) {
          this.$message.success('提交成功，请等待审批');
          this.dialogVisible = false;
          location.reload();
        } else {
          this.$message.error(data.msg);
        }
      },
      // 获取库存数量
      async getStockNumber(billNo) {
        const { data } = await this.$axios.post(
          `${superviseBillApi.BILL_RELEASE_QUERY_STOCK}/${billNo}`
        );
        if (data.code == 0) {
          this.form.canUseStockQuantity = data.data.canUseStockQuantity;
          this.form.outStockQuantity = data.data.outStockQuantity;
          this.judgeNeeds();
        } else {
          this.$message.error('查询库存失败');
        }
      },
      // 判断是否满足要求
      judgeNeeds() {
        if (this.form.canUseStockQuantity < this.form.outStockQuantity) {
          this.isSatisfyNeeds = false;
          this.isShowDownBtn = true;
        } else {
          this.isSatisfyNeeds = true;
          this.isShowDownBtn = false;
        }
      },
    },
    comments: {
      FileTable,
    },
    watch: {
      selectData: {
        handler(val) {
          this.selectData = val;
          this.billNo = val.billNo;
          this.form.id = val.id;
          this.getStockNumber(this.billNo);
          console.log(this.selectData, 'select');
        },
        immediate: false,
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .sirui-table {
    width: 500px;
    margin-top: -50px;
  }
  .el-select {
    width: 320px;
  }
  .el-form {
    margin-top: 15px;
  }
  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
